import {
  AppstoreOutlined,
  BarsOutlined,
  CaretRightOutlined,
  DeleteOutlined,
  DownloadOutlined,
  SearchOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import {
  Button,
  ConfigProvider,
  Input,
  Segmented,
  Space,
  Spin,
  Table,
  message,
} from "antd";
import { ReactComponent as Search } from "asset/address/search.svg";
import { useCallback, useEffect, useState } from "react";
// import 'antd/dist/antd.css';
import { ReactComponent as Circle } from "asset/record/circle_121.svg";
import { ReactComponent as NoRecordSVG } from "asset/record/no_record_img.svg";
import axios from "axios";
import style from "css/record.module.css";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { closeAlert, openAlert, openConfirm } from "redux/slices/alertSlice";

function Record() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [listStyle, setListStyle] = useState("card"); // 디스플레이 타입(리스트, 카드)
  const [search, setSearch] = useState(""); //
  const [isSearch, setIsSearch] = useState(true); // 녹화파일 검색
  // const [recordTotal, setRecordTotal] = useState('');
  const [recordInfo, setRecordInfo] = useState([]); // 녹화파일 데이터 리스트
  const [datelist, setDatelist] = useState([]); // 녹화파일 데이터 날짜 리스트
  // const [chkList, setChkList] = useState([]);             // 체크된 항목 리스트

  // 녹화파일 데이터
  const getRecordFileList = useCallback(() => {
    const config = {
      params: {
        SEARCH: search,
      },
    };
    axios
      .get("/record/data", config)
      .then((res) => {
        setLoading(true);
        if (res.status === 200) {
          let list = [];
          let date = [];
          for (let i = 0; i < res.data.length; i++) {
            date.push(res.data[i].START_TIME.substring(0, 10));
            list.push({
              key: i + 1,
              RECORD_DT: res.data[i].START_TIME.substring(0, 10),
              RECORD_TITLE: res.data[i].RECORD_TITLE,
              STHM: res.data[i].STHM,
              EDHM: res.data[i].EDHM,
              REC_TM: tmEngConverter(res.data[i].REC_TM),
              GROUP: "GROUP",
              FUNC: {
                PLAY_URL: res.data[i].PLAY_URL,
                DOWNLOAD_URL: res.data[i].DOWNLOAD_URL,
                RECORD_ID: res.data[i].RECORD_ID,
                RECORD_TITLE: res.data[i].RECORD_TITLE,
              },
            });
          }
          setDatelist([...new Set(date)]);
          setRecordInfo(list);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [search]);

  useEffect(() => {
    if (isSearch) {
      getRecordFileList();
      setIsSearch(false);
      // groups.push(groupItems(recordInfo, 'RECORD_DT'));
      // setGroups(groupItems(recordInfo, 'RECORD_DT'));
    }
  }, [datelist, getRecordFileList, isSearch, recordInfo]);

  useEffect(() => {
    setIsSearch(true);
  }, [i18n.language]);

  const tmEngConverter = (value) => {
    if (i18n.language === "en-US") {
      return value.replace("시간", "h").replace("분", "m").replace("초", "s");
    } else {
      return value;
    }
  };

  // 파일 다운로드 시 cnt 증가
  const updateDownloadCnt = (recordID) => {
    const config = {
      params: {
        RECORD_ID: recordID,
      },
    };
    axios
      .get("/record/download", config)
      .then((res) => {
        if (res.status === 200) {
          messageApi.open({
            type: "success",
            content: t("MESSAGE.RCD_DOWNLOAD_SUCCEED"),
          });
        }
      })
      .catch((err) => {
        console.log(err);
        messageApi.open({
          type: "error",
          content: t("MESSAGE.RCD_DOWNLOAD_FAILED"),
        });
      });
  };

  const [messageApi, contextHolder] = message.useMessage();
  // 공유 버튼 시 클립보드에 파일 url 복사
  const handleCopyClipBoard = async (copyURL, recTitle) => {
    try {
      await navigator.clipboard.writeText(copyURL);
      messageApi.open({
        type: "success",
        content: t("MESSAGE.LINK_COPY_SUCCEED"),
      });
    } catch (e) {
      messageApi.open({
        type: "error",
        content: t("MESSAGE.LINK_COPY_FAILED"),
      });
    }
  };

  // 파일 삭제
  const deleteRecordFile = (recordID) => {
    // console.log("delete id : " + recordID);
    const config = {
      params: {
        RECORD_ID: recordID,
      },
    };
    axios
      .get("/record/delete", config)
      .then((res) => {
        if (res.status === 200) {
          const obj = {
            title: t("MESSAGE.NOTIFICATION"),
            content: t("MESSAGE.DELETE_COMPLETE"),
            submitEventHandler: () => {
              dispatch(closeAlert());
            },
          };
          dispatch(openAlert(obj));
          setIsSearch(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const columns = [
    {
      title: t("LIST.RECORD_DATE"),
      dataIndex: "RECORD_DT",
      key: "RECORD_DT",
      align: "center",
      width: "15%",
      sorter: (a, b) => new Date(a.RECORD_DT) - new Date(b.RECORD_DT),
    },
    {
      title: t("LIST.FILE_NAME"),
      dataIndex: "RECORD_TITLE",
      key: "RECORD_TITLE",
      align: "center",
      width: "30%",
      sorter: (a, b) => a.RECORD_TITLE.localeCompare(b.RECORD_TITLE),
    },
    {
      title: t("LIST.MEETING_START"),
      dataIndex: "STHM",
      key: "STHM",
      align: "center",
      width: "10%",
    },
    {
      title: t("LIST.MEETING_END"),
      dataIndex: "EDHM",
      key: "EDHM",
      align: "center",
      width: "10%",
    },
    {
      title: t("LIST.RECORDING_TIME"),
      dataIndex: "REC_TM",
      key: "REC_TM",
      align: "center",
      width: "10%",
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      key: "FUNC",
      width: "25%",
      render: (_, el) => (
        <Space size="middle">
          <a href={el.FUNC.PLAY_URL} target="_blank" rel="noreferrer">
            <Button className={style.record_list_btn}>
              <CaretRightOutlined className={style.record_list_btn_icon} />
            </Button>
          </a>
          <a href={el.FUNC.DOWNLOAD_URL} target="_blank" rel="noreferrer">
            <Button
              onClick={() => updateDownloadCnt(el.FUNC.RECORD_ID)}
              className={style.record_list_btn}
            >
              <DownloadOutlined className={style.record_list_btn_icon} />
            </Button>
          </a>
          <Button
            onClick={() =>
              handleCopyClipBoard(el.FUNC.PLAY_URL, el.FUNC.RECORD_TITLE)
            }
            className={style.record_list_btn}
          >
            <ShareAltOutlined className={style.record_list_btn_icon} />
          </Button>
          <Button
            onClick={() => {
              const obj = {
                title: t("MESSAGE.NOTIFICATION"),
                content: t("MESSAGE.DELETE_SCD"),
                submitEventHandler: () => {
                  deleteRecordFile(el.FUNC.RECORD_ID);
                  dispatch(closeAlert());
                },
              };
              dispatch(openConfirm(obj));
            }}
            className={style.record_list_btn}
          >
            <DeleteOutlined className={style.record_list_btn_icon} />
          </Button>
        </Space>
      ),
    },
  ];

  const NoRecord = () => {
    return (
      <div
        className={style.record_noRecord_wrapper}
        style={{ height: listStyle === "card" ? "750px" : "660px" }}
      >
        <div className={style.record_noRecord_container}>
          <NoRecordSVG />
          <div className={style.record_noRecord_topTxt}>
            {i18n.language === "en-US"
              ? "No record file"
              : "녹화된 파일이 없습니다"}
          </div>
          <div className={style.record_noRecord_botTxt}>
            {i18n.language === "en-US" ? (
              <>
                Recorded files are listed here if you have enabled the recording
                function for the meeting.
                <br />
                Files are kept for <span>1 month</span> and are permanently
                delete after then.
              </>
            ) : (
              <>
                회의를 예약할 때나 중간에 녹화를 하게 되면 파일 정보가 이곳에
                리스트업됩니다.
                <br />
                녹화 파일은 <span>1개월간</span> 보관되며 이후에는 영구적으로
                삭제됩니다.
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  // 날짜 포맷 변환
  const convertDateFormat = (date) => {
    if (i18n.language === "en-US") {
      return moment(date, "YY-MM-DD").locale("en").format("YYYY.MM.DD ddd");
    } else {
      return moment(date, "YY-MM-DD").locale("ko").format("YYYY.MM.DD ddd");
    }
  };

  return (
    <div className={style.record_container}>
      {contextHolder}
      <div className={style.record_wrapper}>
        <div className={style.record_header}>
          <div className={style.record_searchbox}>
            <Input
              // className={style.record_searchinput}
              className="inputbox-size"
              placeholder={t("PLACEHOLDER.SEARCH.FILE_TITLE")}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setIsSearch(true);
                }
              }}
              suffix={
                <SearchOutlined
                  className="search-btn"
                  onClick={() => setIsSearch(true)}
                />
              }
            />
          </div>
          <ConfigProvider
            theme={{
              components: {
                Segmented: {
                  colorText: "#1cb691",
                  colorTextLabel: "#7b7b7b",
                  borderRadius: 5,
                  controlPaddingHorizontal: 10,
                  fontFamily: "Spoqa Han Sans Neo",
                },
              },
            }}
          >
            <div className="segmented">
              <Segmented
                size="large"
                options={[
                  {
                    // label: '카드',
                    value: "card",
                    icon: <AppstoreOutlined style={{ fontSize: "24px" }} />,
                  },
                  {
                    // label: '리스트',
                    value: "list",
                    icon: <BarsOutlined style={{ fontSize: "24px" }} />,
                  },
                ]}
                value={listStyle}
                onChange={(value) => {
                  setListStyle(value);
                }}
                // className={style.record_segmented}
              />
            </div>
          </ConfigProvider>
        </div>

        <div className={style.record_body}>
          {listStyle === "list" ? (
            <div className={style.record_list_wrapper} key="list">
              <div className="list">
                <Table
                  columns={columns}
                  dataSource={recordInfo}
                  loading={loading}
                  locale={{ emptyText: <NoRecord /> }}
                  className={style.record_list_table}
                />
              </div>
            </div>
          ) : loading ? (
            <div className="spin-container">
              <Spin />
            </div>
          ) : (
            <>
              {recordInfo.length === 0 ? (
                <NoRecord />
              ) : (
                datelist.map((date, listIdx) => (
                  <div key={date + "_" + listIdx}>
                    <div className={style.record_date} key={"date_" + listIdx}>
                      {convertDateFormat(date)}
                    </div>
                    <div
                      className={style.record_cardlist}
                      key={"cardlist_" + listIdx}
                    >
                      {recordInfo.map((el, infoIdx) =>
                        // <div key={el.RECORD_DT + '_' + infoIdx}>
                        // {
                        date === el.RECORD_DT ? (
                          <div
                            key={el.recordID + "_" + listIdx + "_" + infoIdx}
                          >
                            <label htmlFor={infoIdx}>
                              <div
                                className={`${style.record_card}`}
                                // onMouseOver={console.log('mouse over')}
                              >
                                <Circle className={style.record_circle} />
                                <div className={style.record_cardContent}>
                                  {/* <div className={style.record_cardContent_checkbox}>
                                                                                                <Checkbox
                                                                                                    id={infoIdx}
                                                                                                    className={`${style.record_card_checkbox} cursor`}
                                                                                                    checked={chkList.includes(el.FUNC.RECORD_ID)}
                                                                                                    onChange={(e) => {
                                                                                                        if (e.target.checked) {
                                                                                                            setChkList([...chkList, el.FUNC.RECORD_ID]);
                                                                                                        } else {
                                                                                                            setChkList(chkList.filter(id => id !== el.FUNC.RECORD_ID))
                                                                                                        }
                                                                                                    }}
                                                                                                />
                                                                                            </div> */}
                                  <div>
                                    <div
                                      className={style.record_cardContent_title}
                                    >
                                      <span>{el.RECORD_TITLE}</span>
                                    </div>
                                    <div
                                      className={style.record_cardContent_time}
                                    >
                                      {el.STHM +
                                        " ~ " +
                                        el.EDHM +
                                        " (" +
                                        el.REC_TM +
                                        ")"}
                                    </div>
                                  </div>
                                  <div className={style.record_cardContent_btn}>
                                    <a
                                      href={el.FUNC.PLAY_URL}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <Button className={style.record_card_btn}>
                                        <CaretRightOutlined
                                          className={style.record_card_btn_icon}
                                        />
                                      </Button>
                                    </a>
                                    <a
                                      href={el.FUNC.DOWNLOAD_URL}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <Button
                                        onClick={() =>
                                          updateDownloadCnt(el.FUNC.RECORD_ID)
                                        }
                                        className={style.record_card_btn}
                                      >
                                        <DownloadOutlined
                                          className={style.record_card_btn_icon}
                                        />
                                      </Button>
                                    </a>
                                    <Button
                                      onClick={() =>
                                        handleCopyClipBoard(
                                          el.FUNC.PLAY_URL,
                                          el.FUNC.RECORD_TITLE
                                        )
                                      }
                                      className={style.record_card_btn}
                                    >
                                      <ShareAltOutlined
                                        className={style.record_card_btn_icon}
                                      />
                                    </Button>
                                    <Button
                                      onClick={() => {
                                        const obj = {
                                          title: t("MESSAGE.NOTIFICATION"),
                                          content: t("MESSAGE.DELETE_SCD"),
                                          submitEventHandler: () => {
                                            deleteRecordFile(el.FUNC.RECORD_ID);
                                            dispatch(closeAlert());
                                          },
                                        };
                                        dispatch(openConfirm(obj));
                                      }}
                                      className={style.record_card_btn}
                                    >
                                      <DeleteOutlined
                                        className={style.record_card_btn_icon}
                                      />
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div>
                        ) : (
                          <></>
                        )
                        // }
                        // </>
                      )}
                    </div>
                  </div>
                ))
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Record;
